import angular from 'angular'
import './coupons.service'
import './edit/edit.controller'

angular
  .module('admin.coupons', ['admin.coupons.edit', 'admin.coupons.service'])
  .controller('CouponsCtrl', CouponsCtrl)

/** @ngInject */
function CouponsCtrl($scope, $state, $timeout, $stateParams, CouponsService) {
  var vm = this
  vm.itemsUnpublished = []
  vm.itemsPublished = []
  vm.itemsArchived = []
  vm.model = {}

  vm.perPage = 25

  vm.portionTime = function(durationInSeconds) {
    if (!durationInSeconds) return '-'
    var tempTime = moment.duration(durationInSeconds / 1000000).humanize()
    return tempTime
  }

  function reloadPaginationUnpublished() {
    vm.totalUsersUnpublished = 0
    vm.oldPageUnpublished = 0
    vm.currentPageUnpublished = 25
    vm.firstUnpublished = true
    vm.totalItemsUnpublished = 0
    vm.paginationUnpublished = {
      current: 1,
    }
  }

  function reloadPaginationPublished() {
    vm.totalUsersPublished = 0
    vm.oldPagePublished = 0
    vm.currentPagePublished = 25
    vm.firstPublished = true
    vm.totalItemsPublished = 0
    vm.paginationPublished = {
      current: 1,
    }
  }

  function reloadPaginationArchived() {
    vm.totalUsersArchived = 0
    vm.oldPageArchived = 0
    vm.currentPageArchived = 25
    vm.firstArchived = true
    vm.totalItemsArchived = 0
    vm.paginationArchived = {
      current: 1,
    }
  }

  vm.sortTypeUnpublished = 'id-desc'
  vm.sortReverseUnpublished = true
  vm.sortTypePublished = 'id-desc'
  vm.sortReversePublished = true
  vm.sortTypeArchived = 'id-desc'
  vm.sortReverseArchived = true

  var tab = localStorage.getItem('tabcoupons')
  if (tab !== null) {
    if (tab === 'unpublished') {
      $('#published').removeClass('active')
      $('#archived').removeClass('active')
      $('#unpublished').addClass('active')
      $('#unpublishedtab').addClass('active')
    } else if (tab === 'published') {
      $('#unpublished').removeClass('active')
      $('#archived').removeClass('active')
      $('#published').addClass('active')
      $('#publishedtab').addClass('active')
    } else {
      $('#unpublished').removeClass('active')
      $('#published').removeClass('active')
      $('#archived').addClass('active')
      $('#archivedtab').addClass('active')
    }
  } else {
    $('#unpublished').addClass('active')
    $('#unpublishedtab').addClass('active')
  }

  reloadPaginationUnpublished()
  reloadPaginationPublished()
  reloadPaginationArchived()
  loadUnpublished(1)
  loadPublished(1)
  loadArchived(1)

  var oldSortTypeUnpublished
  function loadUnpublished(pageNumber) {
    if (pageNumber === 1) {
      vm.paginationUnpublished.current = 1
    }
    if (!vm.firstUnpublished) {
      vm.currentPageUnpublished = pageNumber * 25
      vm.oldPageUnpublished = vm.currentPageUnpublished - 25
    } else {
      vm.firstUnpublished = false
    }

    oldSortTypeUnpublished = angular.copy(vm.sortTypeUnpublished)
    CouponsService.listUnpublished(vm.oldPageUnpublished, vm.perPage, vm.sortTypeUnpublished).then(
      function(result) {
        var items = result.results
        if (vm.totalItemsUnpublished === 0) {
          vm.totalItemsUnpublished = result.ct
        }
        for (var i = 0; i < items.length; i++) {
          if (items[i]['ts-x']) {
            items[i]['ts-x'] = new Date(parseInt(items[i]['ts-x'] / 1000))
          }
          if (items[i]['ts-start']) {
            items[i]['ts-start'] = new Date(parseInt(items[i]['ts-start'] / 1000))
          }

          if (items[i]['k-cr'] === 1) {
            items[i]['k-cr'] = 'Primary Market'
          } else if (items[i]['k-cr'] === 2) {
            items[i]['k-cr'] = 'Aftermarket'
          }
        }

        vm.sortTypeUnpublished = oldSortTypeUnpublished
        vm.itemsUnpublished = items
      },
    )
  }

  var oldSortTypePublished
  function loadPublished(pageNumber) {
    if (pageNumber === 1) {
      vm.paginationPublished.current = 1
    }
    if (!vm.firstPublished) {
      vm.currentPagePublished = pageNumber * 25
      vm.oldPagePublished = vm.currentPagePublished - 25
    } else {
      vm.firstPublished = false
    }

    oldSortTypePublished = angular.copy(vm.sortTypePublished)
    CouponsService.listPublished(vm.oldPagePublished, vm.perPage, vm.sortTypePublished).then(
      function(result) {
        var items = result.results
        if (vm.totalItemsPublished === 0) {
          vm.totalItemsPublished = result.ct
        }
        for (var i = 0; i < items.length; i++) {
          if (items[i]['ts-x']) {
            items[i]['ts-x'] = new Date(parseInt(items[i]['ts-x'] / 1000))
          }
          if (items[i]['ts-start']) {
            items[i]['ts-start'] = new Date(parseInt(items[i]['ts-start'] / 1000))
          }
        }

        vm.sortTypePublished = oldSortTypePublished
        vm.itemsPublished = items
      },
    )
  }

  var oldSortTypeArchived
  function loadArchived(pageNumber) {
    if (pageNumber === 1) {
      vm.paginationArchived.current = 1
    }
    if (!vm.firstArchived) {
      vm.currentPageArchived = pageNumber * 25
      vm.oldPageArchived = vm.currentPageArchived - 25
    } else {
      vm.firstArchived = false
    }

    oldSortTypeArchived = angular.copy(vm.sortTypeArchived)
    CouponsService.listArchived(vm.oldPageArchived, vm.perPage, vm.sortTypeArchived).then(function(
      result,
    ) {
      var items = result.results
      if (vm.totalItemsArchived === 0) {
        vm.totalItemsArchived = result.ct
      }
      for (var i = 0; i < items.length; i++) {
        if (items[i]['ts-x']) {
          items[i]['ts-x'] = new Date(parseInt(items[i]['ts-x'] / 1000))
        }
        if (items[i]['ts-start']) {
          items[i]['ts-start'] = new Date(parseInt(items[i]['ts-start'] / 1000))
        }
      }

      vm.sortTypeArchived = oldSortTypeArchived
      vm.itemsArchived = items
    })
  }

  vm.pageChangedUnpublished = function(newPage) {
    vm.sortTypeUnpublished = oldSortTypeUnpublished
    loadUnpublished(newPage)
  }

  vm.pageChangedPublished = function(newPage) {
    vm.sortTypePublished = oldSortTypePublished
    loadPublished(newPage)
  }

  vm.pageChangedArchived = function(newPage) {
    vm.sortTypeArchived = oldSortTypeArchived
    loadArchived(newPage)
  }

  vm.tabUnpublished = function() {
    $('#published').removeClass('active')
    $('#archived').removeClass('active')
    $('#unpublished').addClass('active')
    localStorage.setItem('tabcoupons', 'unpublished')
  }

  vm.tabPublished = function() {
    $('#unpublished').removeClass('active')
    $('#archived').removeClass('active')
    $('#published').addClass('active')
    localStorage.setItem('tabcoupons', 'published')
  }

  vm.tabArchived = function() {
    $('#unpublished').removeClass('active')
    $('#published').removeClass('active')
    $('#archived').addClass('active')
    localStorage.setItem('tabcoupons', 'archived')
  }

  vm.add = function() {
    $state.go('admin.coupons.edit', { id: 0 })
  }

  vm.edit = function(item) {
    $state.go('admin.coupons.edit', { id: item.id })
  }

  vm.delete = function(item) {
    swal(
      {
        title: 'Are you sure?',
        text: '',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function(isConfirm) {
        if (isConfirm) {
          CouponsService.remove(item.id).then(
            function() {
              $state.reload()
            },
            function(err) {
              swal('Error', err.data.message, 'error')
            },
          )
        } else {
          return
        }
      },
    )
  }

  vm.sortUnpublished = function(type) {
    vm.sortReverseUnpublished = !vm.sortReverseUnpublished
    if (vm.sortReverseUnpublished) {
      vm.sortTypeUnpublished = type + '-asc'
    } else {
      vm.sortTypeUnpublished = type + '-desc'
    }
    loadUnpublished(vm.paginationUnpublished.current)
  }

  vm.sortPublished = function(type) {
    vm.sortReversePublished = !vm.sortReversePublished
    if (vm.sortReversePublished) {
      vm.sortTypePublished = type + '-asc'
    } else {
      vm.sortTypePublished = type + '-desc'
    }
    loadPublished(vm.paginationPublished.current)
  }

  vm.sortArchived = function(type) {
    vm.sortReverseArchived = !vm.sortReverseArchived
    if (vm.sortReverseArchived) {
      vm.sortTypeArchived = type + '-asc'
    } else {
      vm.sortTypeArchived = type + '-desc'
    }
    loadArchived(vm.paginationArchived.current)
  }

  vm.publish = function(item) {
    CouponsService.publish(item.id).then(function() {
      toastr.success('Coupon published')
      $state.reload()
    })
  }

  vm.unpublish = function(item) {
    CouponsService.unpublish(item.id).then(function() {
      toastr.success('Coupon Unpublished')
      $state.reload()
    })
  }

  vm.archive = function(item) {
    CouponsService.archive(item.id).then(function() {
      toastr.success('Coupon archived')
      $state.reload()
    })
  }

  vm.clone = function(item) {
    var model = angular.copy(item)
    model.id = 0
    model['ts-p'] = null
    model.st = 0
    delete model['ts']
    delete model['ts-m']

    swal(
      {
        title: 'Are you sure?',
        text: '',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function(isConfirm) {
        if (isConfirm) {
          CouponsService.save(model).then(function() {
            toastr.success('Coupon cloned')
            $state.reload()
          })
        }
      },
    )
  }
}
